module.exports = __webpack_public_path__ + "static/media/floorG.ee8a79e5.png";